import { useAppSelector } from '@/store/hooks';
import { useMemo } from 'react';
import { Helmet } from 'react-helmet';

interface IProps {
  screenTitle?: string;
}

const PageTitle = ({ screenTitle }: IProps) => {
  const {
    whitelabel: { favicon, isDefault, whitelabelName },
    whitelabelRequestId: whitelabelLoading,
  } = useAppSelector(state => state.currentWhitelabel);

  const fullTitle = useMemo(() => {
    if (whitelabelLoading) {
      return document.title;
    }
    return screenTitle ? `${whitelabelName} - ${screenTitle}` : whitelabelName;
  }, [whitelabelLoading, whitelabelName, screenTitle]);

  return (
    <Helmet>
      {favicon && !isDefault ? <link rel='icon' href={favicon} /> : null}
      <title>{fullTitle}</title>
    </Helmet>
  );
};

export default PageTitle;
